<template>
  <div>
    <v-parallax
      class="landing__background"
      src="@/assets/images/bg.jpg"
      :height="height"
    >
      <!-- <h1 class="text-center"> -->
      <v-row
        class="header__items"
        align="center"
        justify="center"
        v-show="showHeaderText"
      >
        <v-col class="landing__logo_container" md="12">
          <v-img class="landing__logo" src="@/assets/logo-red-white-text.png" />
        </v-col>
        <v-col class="display-1" md="12">
          <div class="landing__text">
            <span class="landing__text-decorator">-</span>
            Witaj w&nbsp;gronie ekspertów
            <span class="landing__text-decorator">-</span>
          </div>
        </v-col>
      </v-row>
      <!-- </h1> -->
    </v-parallax>
  </div>
</template>

<script>
import imageUrl from '@/assets/logo-red-white-text.png';
import { mapState } from 'vuex';

export default {
  name: 'Header',
  data() {
    return {
      height: window.innerHeight,
      preloadedHeaderImage: (new Image().src = imageUrl),
    };
  },
  computed: {
    ...mapState(['showHeaderText']),
  },
  mounted() {
    window.addEventListener('resize', this.changeHeight);
  },
  destroyed() {
    window.removeEventListener('resize', this.changeHeight);
  },
  methods: {
    changeHeight() {
      this.height = window.innerHeight;
    },
  },
};
</script>

<style scoped>
@keyframes slideInFromLeft {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes slideInFromRight {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}

.header__items {
  max-height: 300px;
}
.landing__background img {
  filter: grayscale(50%);
}
.landing__logo {
  max-width: 800px;
  margin: auto;
  margin-bottom: 60px;
  animation: 1.8s ease-out 0s 1 slideInFromLeft;
}
.landing__text {
  font-family: 'Source Sans Pro', sans-serif !important;
  font-weight: normal;
  font-size: 52px;
  text-align: center;
  max-width: 840px;
  margin: auto;
  transition: all 0.3s;
  vertical-align: 16px;
  padding: 10px;
  /* border-left: 5px solid #ff3c3c; */
  animation: 1.8s ease-out 0s 1 slideInFromRight;
}
.landing__text-decorator {
  transition: all 0.3s;
}
.landing__text:hover .landing__text-decorator {
  color: rgb(190, 11, 62);
}
@media screen and (max-width: 798px) {
  .landing__text {
    font-size: 40px;
  }
}
</style>
